export default function IconFilter({ size = 24 }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        width={size}
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M3 5h18l-7 8v6l-4-2v-4L3 5z"/>
      </svg>
    );
  }